module.exports = __webpack_public_path__ + "img/ford_commercial_logo_white.f2019a73.png";